import Sizzle from 'sizzle';

export default function (videoElement, callback) {
    // Read video urls from source elements
    const videoData = {};
    const sourceElements = Sizzle('source', videoElement);

    sourceElements.forEach((item) => {
        const dataType = item.getAttribute('data-type');

        if (dataType) {
            videoData[dataType] = item.getAttribute('src');
        }
    });

    callback({}, videoData, {});
}



// WEBPACK FOOTER //
// ./src/js/api/metadata-fetch-from-source.js